<div class="d-flex flex-column justify-content-center mx-5 my-5">
    <H1 class="text-center"><i class="fas fa-ban"></i> No Results for Filter.</H1>
    <div class="text-center">
        <p class="text-center">Please refine your search as the
            number of items is either returned is larger than the number we can skip in the search index. <br/> OR <br/>The facets
            you selected yielded no results. Please use the facets or a new search to filter the items.</p>
    </div>
</div>